import React from 'react';
import {truncate} from 'lodash';

import {Text, Tooltip} from '@phonectas/unifon-ui-kit';
import {StyledLabel} from '../TextDivWithLabel/styled';
import {Wrapper} from './styled';

interface TextWithLabelProps {
    text: string | number;
    label: string;
    textColor?: string;
    toUpperCase?: boolean;
    truncated?: boolean;
    gap?: boolean;
}

const TextWithLabel: React.FC<TextWithLabelProps> = ({
	text,
	label,
	textColor,
	toUpperCase = false,
	truncated = false,
	gap = false,
}) => {
	const truncatedText = truncate(String(text), {length: 20});
	const isTextNa = text === 'N/A';

	return (
		<Wrapper $gap={gap}>
			{
				truncated && !isTextNa ? (
					<>
						<StyledLabel>{label}</StyledLabel>
						<Tooltip
							text={text}
						>
							<div>
								<Text style={{
									color: textColor,
									cursor: isTextNa ? 'default' : 'pointer',
								}}>
									{truncatedText}
								</Text>
							</div>
						</Tooltip>
					</>
				) : (
					<>
						<StyledLabel>{label}</StyledLabel>
						<Text style={{color: textColor}}>
							{toUpperCase ? String(text).toUpperCase() : text }
						</Text>
					</>
				)
			}
		</Wrapper>
	);
}

export default TextWithLabel;
